import {
  NRMA,
  RACV,
  RACQ,
  RAA,
  RAC,
  RACT,
  AANT,
  NRMAC,
  RACVC,
  RACQC,
  RAAC,
  RACC,
  RACTC,
  AANTC,
} from "@components/atoms/Logo"
import { cn, tv } from "@utils/tw"
import { Link } from "eddev/routing"
import { forwardRef } from "react"
import { useEffect, useState } from "react"

export const LogoRotation = ({ color }: { color: boolean }) => {
  const [active, setActive] = useState<number>(1)
  useEffect(() => {
    const interval = setInterval(() => {
      if (active === 7) {
        setActive(1)
      } else {
        setActive(active + 1)
      }
    }, 2000)

    return () => clearInterval(interval)
  }, [active])

  return (
    <div className="w-[38px] h-[38px] relative">
      {color ? (
        <>
          <ClubLogo title="NRMA" href="https://mynrma.com.au" target="_blank" active={active === 1 ? true : false}>
            <NRMAC />
          </ClubLogo>
          <ClubLogo title="RACV" href="https://racv.com.au" target="_blank" active={active === 2 ? true : false}>
            <RACVC />
          </ClubLogo>
          <ClubLogo title="RACQ" href="https://racq.com.au" target="_blank" active={active === 3 ? true : false}>
            <RACQC />
          </ClubLogo>
          <ClubLogo title="RAA" href="https://raa.com.au" target="_blank" active={active === 4 ? true : false}>
            <RAAC />
          </ClubLogo>
          <ClubLogo title="RAC" href="https://rac.com.au" target="_blank" active={active === 5 ? true : false}>
            <RACC />
          </ClubLogo>
          <ClubLogo title="RACT" href="https://ract.com.au" target="_blank" active={active === 6 ? true : false}>
            <RACTC />
          </ClubLogo>
          <ClubLogo title="AANT" href="https://aant.com.au" target="_blank" active={active === 7 ? true : false}>
            <AANTC />
          </ClubLogo>
        </>
      ) : (
        <>
          <ClubLogo title="NRMA" href="https://mynrma.com.au" target="_blank" active={active === 1 ? true : false}>
            <NRMA />
          </ClubLogo>
          <ClubLogo title="RACV" href="https://racv.com.au" target="_blank" active={active === 2 ? true : false}>
            <RACV />
          </ClubLogo>
          <ClubLogo title="RACQ" href="https://racq.com.au" target="_blank" active={active === 3 ? true : false}>
            <RACQ />
          </ClubLogo>
          <ClubLogo title="RAA" href="https://raa.com.au" target="_blank" active={active === 4 ? true : false}>
            <RAA />
          </ClubLogo>
          <ClubLogo title="RAC" href="https://rac.com.au" target="_blank" active={active === 5 ? true : false}>
            <RAC />
          </ClubLogo>
          <ClubLogo title="RACT" href="https://ract.com.au" target="_blank" active={active === 6 ? true : false}>
            <RACT />
          </ClubLogo>
          <ClubLogo title="AANT" href="https://aant.com.au" target="_blank" active={active === 7 ? true : false}>
            <AANT />
          </ClubLogo>
        </>
      )}
    </div>
  )
}

const clubLogoStyles = tv({
  base: "w-full h-full absolute block top-0 left-0 opacity-0 transition-opacity duration-300 ease-movement pointer-events-none [&_svg]:w-full [&_svg]:h-full",
  variants: {
    active: {
      true: "opacity-100 pointer-events-auto",
    },
  },
})

const ClubLogo = forwardRef<HTMLAnchorElement, React.ComponentProps<typeof Link> & { active?: boolean }>(
  ({ active, className, ...props }, ref) => (
    <Link ref={ref} className={cn(clubLogoStyles({ active }), className)} {...props} />
  ),
)
ClubLogo.displayName = "ClubLogo"
